import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useController } from 'react-hook-form';
import { InputGroup, UnitInput } from '@oliasoft-open-source/react-ui-library';
import { round } from '@oliasoft-open-source/units';
import translations from 'src/internationalisation/translation-map.json';
import { linkFields } from 'src/enums/settings';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const linkFieldMapDefault = {
  from: 'depthFromLink',
  to: 'depthToLink',
};

const ForwardedGuiUnitInput = forwardRef((props, ref) => {
  return <UnitInput {...props} inputRef={ref} />;
});
ForwardedGuiUnitInput.displayName = 'ForwardedGuiUnitInput';

const RawUnitInputConvertable = ({
  name,
  control,
  unit,
  unitkey = '',
  errors,
  error = null,
  warning = null,
  onPredefinedChange,
  width,
  linkFieldMap = linkFieldMapDefault,
  onChange,
  ...inputProps
}) => {
  const { t } = useTranslation();
  const { field } = useController({
    name,
    control,
  });
  const initialValue = round(field.value, 2);

  const { onChange: fieldOnChange, ...props } = field;
  const customOnChange = (e) => {
    if (onPredefinedChange) {
      const { name, predefinedSelected, predefinedOption } = e.target;
      if (predefinedSelected && predefinedOption.valueKey) {
        onPredefinedChange(linkFieldMap[name], predefinedOption.valueKey);
      } else {
        onPredefinedChange(linkFieldMap[name], linkFields.CUSTOM);
      }
    }
    fieldOnChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <InputGroup width={width}>
      <ForwardedGuiUnitInput
        {...props}
        {...inputProps}
        value={initialValue}
        onChange={customOnChange}
        error={translations[errors[name]] ? t(errors[name]) : errors[name] || error}
        warning={warning}
        initUnit={unit}
        unitkey={unitkey}
      />
    </InputGroup>
  );
};

export const UnitInputConvertable = withErrorBoundary(RawUnitInputConvertable);
